﻿import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Config } from '../../shared/config/config';
import { ActivatedRoute, Router } from '@angular/router';
import { IsurveyDefinition } from '../models/surveyDefinition';
import { IsurveyResult} from '../models/SurveyResult';
import { NotificationsService } from 'angular2-notifications';
import { SurveyTemplateText } from 'survey-angular';
import { read } from 'fs';
import { Imail } from '../models/mail';

declare var config: Config;


@Injectable()
export class SurveyService {


    public static $inject = ['$http'];
    constructor(
        public $http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,

    ) {
    }
    protected get endpoint(): string {
        return config.apiUrl;
    };
   
    private surveyUrl = '/TSurveyDefinitions/';  // URL to web api
   

    ngOnInit(): void { };
    results: string;

    public getSurvey(surveyId: number) {
     
        return this.$http.get<IsurveyDefinition>(this.endpoint + this.surveyUrl + surveyId)
            .toPromise()
            .catch(this.redirectToUnAuthorized);
    }

       public redirectToClosed = (message) => {
        this.router.navigate(['/closed', message]);
    }

    public redirectToUnAuthorized = (message) => {
        this.router.navigate(['/401']);
    }

    public ManageSurveyAnswer(SurveyText :Imail) {

     
        let res = this.$http.post(this.endpoint +'/Email/post/', SurveyText).toPromise();
        return res;
    
    }

    public previewSurvey(surveyId: number) {



        return this.$http.get<IsurveyDefinition>(this.endpoint.replace("/api", "") + '/Designer/TSurveyDefinitions/Editor/' + surveyId)
            .toPromise()
            .catch(this.redirectToUnAuthorized);
    

    }


}